import type { WSearchTranslations } from "./pl";

const GROUP_LABELS: Record<string, string> = {
  catalogs: "Kataloge",
  products: "Produkte",
  articles: "Artikel",
};

export const de: WSearchTranslations = {
  open: "Suche öffnen",
  title: "Suche",
  close: "Schließen",
  searchLabel: "Suche",
  inputLabel: "Suchen",
  placeholder: "Produkte, Kategorien, Seiten suchen...",
  suggestionsLabel: "Vorschläge",
  loading: "Suche...",
  popularLabel: "Beliebte Suchen",
  notConfigured: "Die Suche ist nicht konfiguriert (keine Ergebnisseite).",
  groupLabel: (key) => GROUP_LABELS[key] ?? key,
};
